import { Component, OnInit, Inject } from '@angular/core';
import * as fp2 from 'fingerprintjs2';
import { Router } from '@angular/router';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Logo } from '../../models/logo.model';
import { AuthenticationService } from '../../services/authentication.service';
import { UploadFileService } from '../../services/upload-file.service';
import { CustomizeColorService } from '../../services/customizeColor.service';
import { BgColors } from '../../models/bg_color.model';
import * as localForage from 'localforage';
import { NotificationService } from '../../services/notification.service';
import printJS from 'print-js/src/index';
import { GetLocalForageConFigService } from '../../services/getLocalForage.service';
import * as bwipjs from 'bwip-js';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {
  readonly VAPID_PUBLIC_KEY = 'BFjKxHeLVnQYl80p1Ddp38chTFHjWa23au_1CdxdYagcqCD-lq14fLM9L1Nx00Or3AF0HbLVpt64AXTY1d1xk_k';

  checkVerification = true;
  testvalue = 8492;
  colorBG: BgColors = new BgColors();
  logo: Logo = new Logo();
  url: any;
  keyAccess: any;
  messageError ;
  errorFlag = false;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private uploadFileService: UploadFileService,
    private customizeColor: CustomizeColorService,
    private notificationService: NotificationService,
    private modalService: NgbModal,
    // private swPush: SwPush,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl + 'assets/images/Logo/';
    this.uploadFileService.getFileName()
      .then((res: Logo) => {
        this.logo.lg_content = res.lg_content;
        this.logo.lg_overall = res.lg_overall;
        this.logo.lg_start = res.lg_start;
      });
    this.getColorBG();
  }

  ngOnInit() {
    // if (localStorage.getItem('_user')) { // còn sài, test thử cái dưới
      //const getUser = localForage.getItem('_user').then(result => result);
      //if (getUser) {
      //  this.router.navigate(['/banhang']);
      //}
    localForage.getItem('_user').then(result => {
      if (result) {
        this.router.navigate(['/banhang']);
      }
    });
    if (localStorage.getItem('_dtQBan')) {
        this.router.navigate(['/signin']);
    }
    
  }

  async getColorBG() {
    await this.customizeColor.GetBackground().then(color => {
      // localStorage.setItem('_colorBG', JSON.stringify(color)); // còn sài, test thử cái dưới
      this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
      localForage.setItem('_colorBG', JSON.stringify(color));
      console.log('getColorBG');
      console.log(color);
      this.colorBG = color;
    });
    })
      .catch(err => console.log(err));
  }

  getAcceptKey(submitVerification) {
    const uidCookie = this.getCookie('_acceptKey');
    if (uidCookie) {
      if (uidCookie != '') {
     this.keyAccess = uidCookie;
        this.submitNotification(this.keyAccess);
        this.authenticationService.getAccessDevice(uidCookie)
          .catch(err => {
            // err = 'Không Có UID Cookie';
            this.messageError = err;
            this.modalService.open(submitVerification, { centered: true });
            //fp2.getPromise().then(fp => {
              this.checkVerification = !this.checkVerification;
            //  const values = fp.map(function (component) {
            //    return component.value;
            //  });
              this.keyAccess = uidCookie;
            //});
          });
      }
    } else {
      fp2.getPromise().then(fp => {
        this.checkVerification = !this.checkVerification;
        const values = fp.map(function (component) {
          return component.value;
        });
        this.keyAccess = fp2.x64hash128(values.join(''), 31);
      });
    }
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires = " + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    console.log(document.cookie);
  }


  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i)  {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  // async submitNotification(uid: string) {
  //   const key = this.urlBase64ToUint8Array(this.VAPID_PUBLIC_KEY);
  //   const notifService = this.notificationService;
  //   await navigator.serviceWorker.ready
  //     .then(async registration => {
  //       await registration.pushManager.getSubscription().then(async subscription => {
  //         console.log(subscription);
  //         if (subscription) {
  //           console.log('11111111');
  //           console.log(subscription);
  //           // await notifService.setNotification(subscription, uid);
  //         }
  //         await registration.pushManager.subscribe({
  //           userVisibleOnly: true,
  //           applicationServerKey: key
  //         }).then(async sub => {
  //           console.log(sub);
  //           // await notifService.setNotification(sub, uid);
  //         })
  //       });
  //     })
  //     .then(subscription => {
  //       console.log('22222222');
  //       console.log(subscription);
  //       // return subscription;
  //     }).catch(err => console.log(err));
  // }

  async registerPush(uid: string) {
    const key = this.urlBase64ToUint8Array(this.VAPID_PUBLIC_KEY);
    return await navigator.serviceWorker.ready
      .then(async registration => {
        return await registration.pushManager.getSubscription().then(async subscription => {
          console.log('registration.pushManager.getSubscription');
          console.log(subscription);
          if (subscription) {
            console.log('registration.pushManager.getSubscription - trong dieu kien if');
            return subscription;
          }
          return await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: key
          }).then(async sub => {
            console.log('registration.pushManager.subscribe');
            console.log(sub);
            return sub;
          });
        });
      })
      .then(subscription => {
        console.log('22222222');
        console.log(subscription);
        return subscription;
      });
  }

  submitNotification(uid: string) {
    console.log('Goi ham Noti');
    this.registerPush(uid).then(sub => {
      console.log('Goi ham Noti sw push');
      console.log(sub);
      this.notificationService.setNotification(sub, uid);
    })
    .catch(err => console.error('Could not subscribe to notifications', err));
  }

  async submitAccessKey(submitVerification) {
    if (this.keyAccess) {
      await this.authenticationService.getAccessDevice(this.keyAccess)
      .then (result => {
        this.setCookie('_acceptKey', result, 748250);
        this.submitNotification(this.keyAccess);
      })
      .catch(err => {
        this.messageError = err.message;
        this.modalService.open(submitVerification, { centered: true });
      });
    }
  }

  async submitAccessKey_Land() {
    if (this.keyAccess) {
      await this.authenticationService.getAccessDevice(this.keyAccess)
      .then (result => {
        this.setCookie('_acceptKey', result, 748250);
        this.submitNotification(this.keyAccess);
      })
      .catch(err => {
        this.errorFlag = ! this.errorFlag;
      });
    }
  }
  confirmError()
  {
    this.errorFlag = !this.errorFlag;
  }
  submitCoppyAccesskey(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

//  async TPCloud_GetBGColor() {
//     // this.colorBG = JSON.parse(localStorage.getItem('_colorBG')); // còn sài, test thử cái dưới
//     await localForage.getItem('_colorBG').then((result: any) => {
//       console.log(JSON.parse(result));
//       this.colorBG = JSON.parse(result);
//     })
//     .catch (err => {
//       console.log('Lỗi');
//     });
//   }
}



// WEBPACK FOOTER //
// ./src/app/components/verification/verification.component.ts